import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { NotificationToastComponent } from './components/notification-toast/notification-toast.component';
import { ProfilePopupComponent } from './components/profile-popup/profile-popup.component';

@NgModule({
  declarations: [
    NotificationToastComponent,
    ProfilePopupComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule
  ],
  exports: [
    NotificationToastComponent,
    ProfilePopupComponent
  ]
})
export class SharedModule { }
